var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#085488",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.968 7C.968 3.683 3.683.968 7 .968c2.352 0 4.403 1.327 5.368 3.318M13.032 7c0 3.317-2.715 6.032-6.032 6.032-2.352 0-4.403-1.327-5.368-3.318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.911.787l-.482 3.559-3.62-.483M1.089 13.213l.482-3.559 3.62.483"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceProcessing);
export default __webpack_public_path__ + "static/media/device-processing.b494742423ef745f4fa8819c288bb6d8.svg";
export { ForwardRef as ReactComponent };